import styled from '@emotion/styled';
import { FC, HTMLAttributes, ReactNode } from 'react';

interface IFlexBoxProps extends HTMLAttributes<HTMLDivElement> {
  horizontal?: boolean;
  vertical?: boolean;
  center?: boolean;
  spaceBetween?: boolean;
  spaceEvenly?: boolean;
  gap?: string;
  children: ReactNode | ReactNode[];
  alignCenter?: boolean;
  alignRight?: boolean;
  alignFlexEnd?: boolean;
}

export const FlexBox: FC<IFlexBoxProps> = ({
  horizontal,
  vertical,
  center,
  spaceBetween,
  spaceEvenly,
  children,
  gap,
  alignCenter,
  alignRight,
  alignFlexEnd,
  ...props
}) => {
  return (
    <Container
      horizontal={horizontal}
      vertical={vertical}
      center={center}
      spaceBetween={spaceBetween}
      spaceEvenly={spaceEvenly}
      gap={gap}
      alignCenter={alignCenter}
      alignRight={alignRight}
      alignFlexEnd={alignFlexEnd}
      {...props}
    >
      {children}
    </Container>
  );
};

interface ContainerProps {
  horizontal?: boolean;
  vertical?: boolean;
  center?: boolean;
  spaceBetween?: boolean;
  spaceEvenly?: boolean;
  gap?: string;
  alignCenter?: boolean;
  alignRight?: boolean;
  alignFlexEnd?: boolean;
}

const Container = styled.div<ContainerProps>`
  display: flex;
  ${(props) => props.gap !== undefined && `gap: ${props.gap};`}

  ${(props) => props.horizontal && 'flex-direction: row;'}
  ${(props) => props.vertical && 'flex-direction: column;'}
  ${(props) => props.alignCenter && 'align-items: center;'}
  ${(props) => props.alignRight && 'align-items: right;'}
  ${(props) => props.alignFlexEnd && 'align-items: flex-end;'}

  ${(props) => props.center && 'justify-content: center; align-items: center;'}
    ${(props) => props.spaceBetween && 'justify-content: space-between;'}
    ${(props) => props.spaceEvenly && 'justify-content: space-evenly;'}
`;
